var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.selectCameraDialog,
        callback: function ($$v) {
          _vm.selectCameraDialog = $$v
        },
        expression: "selectCameraDialog",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.t("searchCamera")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.selectCameraDialog = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pb-2",
                            attrs: { justify: "start" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "12", id: "store_list" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 pl-1 pr-1",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _vm.loading == false
                                      ? [
                                          _vm.cameraList.length > 0
                                            ? [
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: { align: "center" },
                                                  },
                                                  _vm._l(
                                                    _vm.cameraList,
                                                    function (item, index) {
                                                      return _c(
                                                        "v-col",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "ma-0 pa-0 pr-2",
                                                          attrs: {
                                                            cols: "auto",
                                                          },
                                                        },
                                                        [
                                                          item.isOnline
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 pa-0 mb-2",
                                                                  attrs: {
                                                                    id: "camera_thumbnail",
                                                                    cols: "auto",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectCamera(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("v-img", {
                                                                    attrs: {
                                                                      src: item.thumbnail,
                                                                      id: "camera_image",
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0",
                                                                      attrs: {
                                                                        cols: "auto",
                                                                        id: "camera_name",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            item.cameraName
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 pa-0 mb-2",
                                                                  attrs: {
                                                                    id: "camera_thumbnail",
                                                                    cols: "auto",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectCamera(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("v-img", {
                                                                    attrs: {
                                                                      src: require("@/assets/images/grey_box.png"),
                                                                      id: "camera_image",
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0",
                                                                      attrs: {
                                                                        cols: "auto",
                                                                        id: "camera_name",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.cameraName
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "ma-0 pa-12",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.t("noCamera"))
                                                    ),
                                                  ]
                                                ),
                                              ],
                                        ]
                                      : [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { justify: "start" },
                                            },
                                            _vm._l(8, function (item) {
                                              return _c(
                                                "v-col",
                                                {
                                                  key: item,
                                                  staticClass:
                                                    "ma-0 pa-0 pr-2 mb-2",
                                                  attrs: {
                                                    cols: "auto",
                                                    align: "center",
                                                  },
                                                },
                                                [
                                                  _c("v-skeleton-loader", {
                                                    attrs: {
                                                      boilerplate: false,
                                                      elevation: "0",
                                                      dark: "",
                                                      type: "image",
                                                      width: "7.5rem",
                                                      height: "5rem",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pt-2 pb-2",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  width: "8rem",
                                  height: "2rem",
                                  id: "grey_btn",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectCameraDialog = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.t("back")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }